var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.434 8.927 11.19.685C10.88.372 10.293.099 9.863.099H1.895C.84.099.02.958.02 1.974V9.98c0 .43.234 1.016.546 1.329l8.243 8.242c.742.742 1.953.742 2.656 0l7.969-7.969c.742-.703.742-1.914 0-2.656m-9.297 9.297L1.895 9.98V1.974h7.968l8.282 8.28zM7.52 5.724c0-1.016-.86-1.875-1.875-1.875-1.055 0-1.875.859-1.875 1.875 0 1.054.82 1.875 1.875 1.875 1.015 0 1.875-.82 1.875-1.875"
  })));
};
export default SvgTag;